module.exports = "<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-md-12\">\n      <div ui-view></div>\n    </div>\n  </div>\n</div>";